import { useSearchParams } from 'react-router-dom';

const ONBOARDING_QUERY_PARAM_KEY = 'showOnboarding';

export const useShowOnboarding = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const closeOnboarding = () => {
    setSearchParams(
      prev => {
        prev.delete(ONBOARDING_QUERY_PARAM_KEY);
        return prev;
      },
      { replace: true }
    );
  };
  return {
    showOnboarding: !!searchParams.get(ONBOARDING_QUERY_PARAM_KEY),
    closeOnboarding,
  };
};
